import { type ReactNode } from 'react'

interface PopupBody {
  className?: string
  children: ReactNode
}
function PopupBody({ className = '', children }: PopupBody) {
  return <div className={`flex w-full flex-col ${className}`}>{children}</div>
}
PopupBody.displayName = 'PopupBody'
export { PopupBody }
export default PopupBody
